import httpApiApplication from 'app/http/httpApiApplication';

export const baseUrl = 'inbox';

export const setInboxRead = (id?: string) => {
  return httpApiApplication.put(`${baseUrl}/${id}`, {});
};

export const counNoReadInbox = () => {
  return httpApiApplication.get(`${baseUrl}/count`).then();
};

export const countAll = (): any => {
  return httpApiApplication.get(`${baseUrl}/allTypes`);
};
